import { makeStyles } from '@mui/styles';

const styles = makeStyles(() => ({
  title: {
    textAlign: 'center',
    width: '600px',
  },
  logo: {
    width: '70%',
    margin: 'auto',
  },
  statusMessage: {
    textAlign: 'center',
    padding: '45px 0 30px 0'
  },
  container: {
    display: 'flex',
    flexDirection: 'row',
    marginRight: '-12px',
    marginLeft: '12px'
  },
  divisionContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '14px 0'
  },
  divisionText: {
    color: '#000',
    fontWeight: 'bold',
    marginRight: '14px',
    fontSize: '18px'
  }
}));

export default styles;
